import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
    content: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
    return (
        <div>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    p: ({ children }) => <p className="mb-2">{children}</p>,
                    strong: ({ children }) => <strong className="font-bold text-foreground">{children}</strong>,
                    em: ({ children }) => <em className="italic">{children}</em>,
                    code: ({ children }) => <code className="!bg-muted px-1 py-0.5 rounded text-sm font-mono !text-foreground">{children}</code>,
                    pre: ({ children }) => <pre className="!bg-muted p-3 !rounded-lg overflow-x-auto mb-2 !text-foreground">{children}</pre>,
                    ul: ({ children }) => <ul className="list-disc list-inside mb-2 !text-muted-foreground">{children}</ul>,
                    ol: ({ children }) => <ol className="list-decimal list-inside mb-2 !text-muted-foreground">{children}</ol>,
                    li: ({ children }) => <li className="mb-1 !text-muted-foreground">{children}</li>,
                    blockquote: ({ children }) => <blockquote className="border-l-4 border-blue-500 pl-4 italic !text-muted-foreground mb-2">{children}</blockquote>,
                    h1: ({ children }) => <h1 className="!text-xl mb-2">{children}</h1>,
                    h2: ({ children }) => <h2 className="!text-lg mb-2">{children}</h2>,
                    h3: ({ children }) => <h3 className="!text-base mb-2">{children}</h3>,
                    a: ({ children, href }) => <a href={href} className="!text-blue-400 light:!text-blue-600 hover:!text-blue-300 light:hover:!text-blue-700 underline">{children}</a>
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};
